import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

import Welcome from './sections/Welcome.vue'

import HomeOverview from './sections/HomeOverview.vue'
import FeatureSelection from './sections/FeatureSelection.vue'
import CamerasSection from './sections/CamerasSection.vue'
import HomeAutomationSection from './sections/HomeAutomationSection.vue'

import ProtectionLevelOverview from './sections/ProtectionLevelOverview.vue'
import ProtectionLevel from './sections/ProtectionLevel.vue'
import LevelConfirmation from './sections/LevelConfirmation.vue'
import AutomationSection from './sections/AutomationSection.vue'
import BuildingSection from './sections/BuildingSection.vue'
import CommunicationsSection from './sections/CommunicationsSection.vue'
import PetsSection from './sections/PetsSection.vue'
import ConcernsSection from './sections/ConcernsSection.vue'
import EnvironmentalSection from './sections/EnvironmentalSection.vue'
import DoorsOverview from './sections/DoorsOverview.vue'
import DoorsSection from './sections/DoorsSection.vue'

import AccessibleAreasSection from './sections/AccessibleAreasSection.vue'
import AreasOfConcernIntroSection from './sections/AreasOfConcernIntroSection.vue'
import WhatIsAreaOfConcern from './sections/WhatIsAreaOfConcern.vue'
import Accessibility from './sections/Accessibility.vue'
import AreasOfConcernTips from './sections/AreasOfConcernTips.vue'
import AocStaging from './sections/AocStaging.vue'
import AreasOfConcernSection from './sections/AreasOfConcernSection.vue'
import AreasOfConcernAdd from './sections/AreasOfConcernAdd.vue'
import CommonlyProtectedAreas from './sections/CommonlyProtectedAreas.vue'

import AocEquipment from './sections/areas-of-concern/AocEquipment.vue'
import AocConfirmation from './sections/areas-of-concern/AocConfirmation.vue'

import AdditionalEquipment from './sections/AdditionalEquipment.vue'

import System from './sections/System.vue'

import LoadingScreen from './sections/LoadingScreen.vue'
import AuthPage from './sections/AuthPage.vue'
import LoginLanding from './sections/LoginLanding.vue'
import TrueAdvice from './sections/TrueAdvice.vue'
import TrueAdviceFire from './sections/TrueAdviceFire.vue'
import TrueAdviceIntrusion from './sections/TrueAdviceIntrusion.vue'

import HelpSection from './sections/HelpSection.vue'
import WhatAreProtectionLevels from './sections/help/WhatAreProtectionLevels.vue'
import HowDoPetsAffectMySecuritySystem from './sections/help/HowDoPetsAffectMySecuritySystem.vue'
import WhatDoesAccessibilityMean from './sections/help/WhatDoesAccessibilityMean.vue'
import WhatIsAdtPulse from './sections/help/WhatIsAdtPulse.vue'
import WhatIsTotalLevelProtection from './sections/help/WhatIsTotalLevelProtection.vue'
import WhatArePetAlleys from './sections/help/WhatArePetAlleys.vue'
import IndoorCameraGuide from './sections/help/IndoorCameraGuide.vue'
import RemoteDoorLockGuide from './sections/help/RemoteDoorLockGuide.vue'
import WhatIsTrueAdvice from './sections/help/WhatIsTrueAdvice.vue'
import SmokeHelp from './sections/help/SmokeHelpPage.vue'
import CoHelp from './sections/help/CoHelpPage.vue'
import MonitoringOverview from './sections/MonitoringOverview.vue'
import InstallContract from './sections/InstallContract.vue'
import SystemReview from './sections/SystemReview.vue'

import HelpEquipment from './sections/HelpEquipment.vue'
import MonitoringPlans from './sections/MonitoringPlans.vue'

import DiscountModal from './components/DiscountModal/DiscountModal.vue'

import CheckoutInstallation from './sections/CheckoutInstallation.vue'
import CheckoutPersonalInformation from './sections/CheckoutPersonalInformation.vue'
import CheckoutPayment from './sections/CheckoutPayment.vue'
import OrderComplete from './sections/OrderComplete.vue'

import TermsAndConditions from './sections/TermsAndConditions.vue'

const router = new VueRouter({
	mode: 'history',
	routes: [
		{ path: '/', redirect: '/assessment' },
		{ path: '/assessment', component: HomeOverview },
		{ path: '/assessment/feature-selection', component: FeatureSelection },
		{ path: '/assessment/cameras', component: CamerasSection },
		{ path: '/assessment/home-automation', component: HomeAutomationSection },
		{ path: '/assessment/environmental', component: EnvironmentalSection },
		
		// { path: '/assessment', redirect: '/assessment/protection-level-overview' },
		{ path: '/assessment/protection-level-overview', component: ProtectionLevelOverview },
		{ path: '/assessment/protection-level', component: ProtectionLevel },
		{ path: '/assessment/level-confirmation', component: LevelConfirmation },
		{ path: '/assessment/automation', component: AutomationSection },
		{ path: '/assessment/building', component: BuildingSection },
		{ path: '/assessment/communications', component: CommunicationsSection },
		{ path: '/assessment/pets', component: PetsSection },
		{ path: '/assessment/concerns', component: ConcernsSection },

		{
			path: '/assessment/help',
			component: HelpSection,
			children: [
				{ path: 'what-are-protection-levels', component: WhatAreProtectionLevels },
				{ path: 'how-do-pets-affect-my-security-system', component: HowDoPetsAffectMySecuritySystem },
				{ path: 'what-does-accessibility-mean', component: WhatDoesAccessibilityMean },
				{ path: 'what-is-adt-pulse', component: WhatIsAdtPulse },
				{ path: 'what-is-total-level-protection', component: WhatIsTotalLevelProtection },
				{ path: 'what-are-pet-alleys', component: WhatArePetAlleys },
				{ path: 'indoor-camera-guide', component: IndoorCameraGuide },
				{ path: 'remote-door-lock-guide', component: RemoteDoorLockGuide },
				{ path: 'what-is-true-advice', component: WhatIsTrueAdvice },
				{ path: 'smoke-communicator-guide', component: SmokeHelp },
				{ path: 'carbon-monoxide-communicator-guide', component: CoHelp },
			]
		},
		{ path: '/assessment/help/equipment', component: HelpEquipment },
		{ path: '/assessment/monitoring-plans', component: MonitoringPlans },

		{ path: '/assessment/doors-overview', component: DoorsOverview },
		{ path: '/assessment/doors', component: DoorsSection },

		{ path: '/assessment/accessible-areas', component: AccessibleAreasSection },
		{ path: '/assessment/areas-of-concern-intro', component: AreasOfConcernIntroSection },
		{ path: '/assessment/what-is-area-of-concern', component: WhatIsAreaOfConcern },
		{ path: '/assessment/accessibility', component: Accessibility },
		{ path: '/assessment/areas-of-concern-tips', component: AreasOfConcernTips },
		{ path: '/assessment/commonly-protected-areas', component: CommonlyProtectedAreas },
		{ path: '/assessment/area-staging', component: AocStaging },
		{ 
			path: '/assessment/areas-of-concern', 
			component: AreasOfConcernSection,
			children: [
				{ path: 'equipment', component: AocEquipment },
				{ path: 'confirmation', component: AocConfirmation }
			]
		},
		{ path: '/assessment/areas-of-concern/add', component: AreasOfConcernAdd },
		{ path: '/assessment/additional-equipment', component: AdditionalEquipment },

		{ path: '/assessment/loading', component: LoadingScreen },
		{ path: '/assessment/login', component: AuthPage },
		{ path: '/assessment/login-landing', component: LoginLanding },
		{ path: '/assessment/register', component: AuthPage },
		{ path: '/assessment/monitoring-overview', component: MonitoringOverview },
		{ path: '/assessment/install-contract', component: InstallContract },
		{ path: '/assessment/system-review', component: SystemReview },
		{ path: '/assessment/system', component: System },

		 { path: '/assessment/true-advice', component: TrueAdvice },
		 { path: '/assessment/true-advice/fire', component: TrueAdviceFire },
		 { path: '/assessment/true-advice/intrusion', component: TrueAdviceIntrusion },

		 { path: '/assessment/checkout', component: CheckoutInstallation },
		 { path: '/assessment/discounts', component: DiscountModal },
		 { path: '/assessment/checkout/personal-information', component: CheckoutPersonalInformation },
		 { path: '/assessment/checkout/payment', component: CheckoutPayment },
		 { path: '/assessment/complete', component: OrderComplete },
		 { path: '/assessment/terms-and-conditions', component: TermsAndConditions },
	]
})

export default router
